import Sorter from '@/models/Sorter'

const PHASE_LABELS = {
  autuacao: 'Autuação',
  penalidade: 'Penalidade'
}

const DEFAULT_PHASE = 'autuacao'

const groupKey = document => `${document.kind}::${document.phase || DEFAULT_PHASE}`

export function phaseLabel(phase) {
  if (!phase)
    return '-'

  return PHASE_LABELS[phase] || phase
}

export function discardedCaptures(count) {
  if (!count)
    return null

  return count === 1 ? '1 captura igual descartada' : `${count} capturas iguais descartadas`
}

export function groupLatestByKindAndPhase(documents) {
  const groups = {}

  documents.forEach(document => {
    const key = groupKey(document)

    if (groups[key])
      groups[key].push(document)
    else
      groups[key] = [document]
  })

  return Object.keys(groups)
    .sort((key, otherKey) => key.localeCompare(otherKey, 'pt-BR'))
    .map(key => Sorter.sortBy(groups[key], 'createdAt', { reverse: true })[0])
}
